// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingIndicator-module__main--nPuUz {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-general-white);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.LoadingIndicator-module__sparks--WWvVu > path:first-child {
    animation: LoadingIndicator-module__sparks--WWvVu 1s infinite;
    animation-direction: alternate;
}

.LoadingIndicator-module__sparks--WWvVu > path:last-child {
    animation: LoadingIndicator-module__sparks--WWvVu 1s infinite;
    animation-direction: alternate;
    animation-delay: 1s;
}

@keyframes LoadingIndicator-module__sparks--WWvVu {
    0% {
        fill: white;
    }
    100% {
        fill: #f5cc80;
    }
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/LoadingIndicator/LoadingIndicator.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6DAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,6DAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".main {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-general-white);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sparks > path:first-child {\n    animation: sparks 1s infinite;\n    animation-direction: alternate;\n}\n\n.sparks > path:last-child {\n    animation: sparks 1s infinite;\n    animation-direction: alternate;\n    animation-delay: 1s;\n}\n\n@keyframes sparks {\n    0% {\n        fill: white;\n    }\n    100% {\n        fill: #f5cc80;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `LoadingIndicator-module__main--nPuUz`,
	"sparks": `LoadingIndicator-module__sparks--WWvVu`
};
export default ___CSS_LOADER_EXPORT___;
